import JobWorkerOfferContactDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferContactDeclinedReason";

export default (value: JobWorkerOfferContactDeclinedReason) => {
    switch (value) {
        case JobWorkerOfferContactDeclinedReason.BudgetIssue:
            return "Insufficient budget";
        case JobWorkerOfferContactDeclinedReason.ChangedMind:
            return "Changed mind about this worker";
        case JobWorkerOfferContactDeclinedReason.FoundAlternativeWorker:
            return "Found alternative worker";
        case JobWorkerOfferContactDeclinedReason.PositionNoLongerRequired:
            return "Position no longer required";
        default:
            return "Unknown";
    }
} 